import { ExperienceDto } from "@intelligems/ig-types";

export const getUserInterfacesFromExperienceDto = (
  experience: ExperienceDto
) => {
  return experience.variations.flatMap((v) => v.userInterfaces ?? []);
};
